module.exports = __webpack_public_path__ + "img/victor-mono-light.d31f124c.png";